var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"create-button-container"},[_c('router-link',{attrs:{"to":_vm.endpoint}},[_c('btn',{attrs:{"size":"lg","type":"primary"}},[_vm._v(_vm._s(_vm.title))])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30735588","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CreateButton.vue
// module id = 772
// module chunks = 0